import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Redirect, Switch } from 'react-router-dom'
import * as auth from './redux/actions'
import axios from 'axios'
import AuthService from 'src/cms/constants/authService'

export function Logout() {
  const dispatch = useDispatch()
  const authService = new AuthService()

  useEffect(() => {
    dispatch(auth.actions.logout())
    document.location.reload()
  }, [dispatch])

  return (
    <Switch>
      <Redirect to='/' />
    </Switch>
  )
}
